import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoDropdownConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';

export const panel1 = new EoFormPanelConfig({
  name: 'form',
  panelContentStyleClass: 'grid',
  config: [
    new EoCustomControlConfig({
      name: 'hospitalID',
      label: 'Νοσοκομείο',
      styleClass: 'col-6',
      control: new FormControl(null)
    })
  ],
});

export const clinicSearchFormConfig: EoFormPanelConfig[] = [panel1];
